/* Highest-priced in-stock card in each required category, across paginated collection inventory. */
(()=>{'use strict';
 const rail=document.querySelector('[data-srn-newly-rail]');if(!rail)return;
 const keys=['nfl','mlb','nba','pokemon','one-piece'];const picked=new Map();
 const parse=(html)=>new DOMParser().parseFromString(html,'text/html').querySelector('[data-srn-price-source]');
 const render=()=>{
   const cards=keys.filter(k=>picked.has(k)).map(k=>document.importNode(picked.get(k),true));
   if(cards.length)rail.replaceChildren(...cards);
   else rail.replaceChildren(Object.assign(document.createElement('p'),{className:'srn-newly-empty',textContent:'Featured cards are on their way. Check back soon.'}));
   for(const key of keys.filter(k=>!picked.has(k))){
     const item=document.createElement('div');item.className='srn-highlight-missing';item.textContent=`${key==='one-piece'?'One Piece':key==='pokemon'?'Pokémon':key.toUpperCase()} — no available cards`;
     rail.append(item);
   }
 };
 const load=async()=>{
   let url='/collections/all?view=srn-price-highlights&sort_by=price-descending';
   const visited=new Set();let pages=0;
   while(url&&!visited.has(url)&&pages<100&&picked.size<keys.length){
     visited.add(url);pages++;
     const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'},signal:AbortSignal.timeout(12000)});
     if(!response.ok)throw Error('Unavailable');
     const source=parse(await response.text());if(!source||source.dataset.sort!=='price-descending')throw Error('Unexpected catalog order');
     source.querySelectorAll('[data-srn-price-category]').forEach(el=>{
       const cat=el.dataset.srnPriceCategory;
       if(keys.includes(cat)&&!picked.has(cat))picked.set(cat,el);
     });
     const next=source.dataset.next;
     url=next?new URL(next,location.origin).pathname+new URL(next,location.origin).search:'';
     if(url&&!url.includes('view=srn-price-highlights')){
       const nextURL=new URL(url,location.origin);nextURL.searchParams.set('view','srn-price-highlights');nextURL.searchParams.set('sort_by','price-descending');url=nextURL.pathname+nextURL.search;
     }
   }
   render();
 };
 load().catch(()=>{if(picked.size)render();else rail.replaceChildren(Object.assign(document.createElement('p'),{className:'srn-newly-empty',textContent:'Featured cards are temporarily unavailable.'}));});
})();
